// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"711":"4e35d227","1277":"21a42d11","1813":"3b84cb63"}[chunkId] + ".chunk.css";
};